module.exports = __webpack_public_path__ + "img/firstNameEle.76173905.svg";